import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { MatTableDataSource } from "@angular/material/table";
import { GlobalsService } from "../../globals.service";
import { AuthKey } from "./authkey.model";

@Injectable()
export class AuthKeyService {
  public authKeyList: AuthKey[];
  public dataSource: MatTableDataSource<AuthKey>;
  public selectedAuthKey: AuthKey;

  public constructor(
    private http: HttpClient,
    private globalsService: GlobalsService,
  ) {
    this.selectedAuthKey = new AuthKey();
  }

  public deleteAuthKey(id: number): Promise<AuthKey> {
    return this.http.delete<AuthKey>(`authkey/${id}`).toPromise();
  }

  public getAuthKeyByKey(ownerKey: string): Promise<AuthKey> {
    return this.http.get<AuthKey>(`authkey/key/${ownerKey}`).toPromise();
  }

  public getAuthKeyList(): Promise<AuthKey[]> {
    if (this.globalsService.isSuperUser()) {
      return this.http.get<AuthKey[]>(`authkey/list/`).toPromise();
    }
  }

  public postAuthKey(authKey: AuthKey) {
    authKey.id = 0;
    authKey.ownerID = this.globalsService.getOwnerID();
    const body = JSON.stringify(authKey);
    return this.http.post<AuthKey>(`authkey`, body);
  }

  public putAuthKey(id, authKey) {
    authKey.ownerID = this.globalsService.getOwnerID();
    const body = JSON.stringify(authKey);
    return this.http.put<AuthKey>(`authkey`, body);
  }

  public refresh() {
    this.getAuthKeyList().then((x) => {
      this.dataSource.data = x;
    });
  }
}
